import {WarehouseLinks} from '../components/shopify/WarehouseLinks';
import { useCallback, useMemo, useState } from "react";
import { Banner, BlockStack, Button, Page } from "@shopify/polaris";
import { useAuth } from "../App";
import { ShopifyJobs } from "../components/ShopifyJobs";
import { PublicationPanel } from "../components/stock-publication/PublicationPanel";
import { PublicationHistory } from "../components/stock-publication/PublicationHistory";
import {
  queueAccountKey,
  type QueueAccount,
} from "../../../packages/shared/shopify-queue/client";
export default function ShopifyUpdates() {
  const { user, currentShop, permissions } = useAuth();
  const account = useMemo(
    () => ({
      userId: String(user?.id || ""),
      domain: currentShop?.domain || "",
      organizationId: currentShop?.organizationId,
    }),
    [user?.id, currentShop?.domain, currentShop?.organizationId],
  );
  const canView =
      permissions.includes("*") || permissions.includes("sync.status.view"),
    canQueue =
      permissions.includes("*") || permissions.includes("inventory.sync");
  return (
    <Page title="Shopify updates">
      {!canView ? (
        <Banner tone="critical">
          You do not have access to Shopify updates.
        </Banner>
      ) : !account.userId || !account.domain ? (
        <Banner>Select a company to view Shopify updates.</Banner>
      ) : (
        <CompanyUpdates
          key={queueAccountKey(account)}
          account={account}
          canQueue={canQueue}
          canViewLinks={permissions.includes("*")||permissions.includes("warehouses.view")}
          canManageLinks={permissions.includes("*")||permissions.includes("warehouses.sync")}
        />
      )}
    </Page>
  );
}
function CompanyUpdates({
  account,
  canQueue,
  canViewLinks,canManageLinks,
}: {
  account: QueueAccount;
  canQueue: boolean;
  canViewLinks:boolean;canManageLinks:boolean;
}) {
  const [refresh, setRefresh] = useState(0);
  const queued = useCallback(() => setRefresh((value) => value + 1), []);
  return (
    <BlockStack gap="400">
      <Button url="/stock-comparison">Compare stock with Shopify</Button>
      {canViewLinks&&<WarehouseLinks account={account} canManage={canManageLinks}/>}
      <PublicationPanel
        account={account}
        canQueue={canQueue}
        onQueued={queued}
      />
      <ShopifyJobs key={refresh} />
      <PublicationHistory account={account} refresh={refresh} />
    </BlockStack>
  );
}
